import { AxiosPromise } from 'axios';

import { IPublishParams } from './interfaces';
import { vaultApi } from '../api';

const basePath = '/publish/assets';

export const publishAssets = <T>(settings: IPublishParams): AxiosPromise<any> => vaultApi.getInstance().post(basePath, settings);
